import { Button, List, ListItem, ListItemButton, Stack } from '@mui/material';
import { useQuery } from '@tanstack/react-query';

import { Alert, Text, api, getQueryProps } from 'common';

import { AgenticChatSessionUpdatedTime } from '../../../components/AgenticChat/Sessions/UpdatedTime';
import { getAgenticChatSessionTitle } from '../../../components/AgenticChat/Sessions/title';
import { useAgenticChatContext } from '../../../components/AgenticChat/context';

export function AgenticChatConversationRecentChats() {
  const { sessionId, selectSession } = useAgenticChatContext();
  const { data, isPending, isError, error, refetch } = useQuery({
    ...getQueryProps(api.client.AgenticPlatformSession, 'findAll', {
      filterMode: 'OnlySessionsWithMessages',
    }),
    select: (sessions) => sessions.slice(0, 3),
  });

  return (
    <Stack gap={1} width="100%">
      <Text variant="heading6" sx={{ paddingLeft: 2 }}>
        Recent chats
      </Text>
      {isPending ? (
        <Text>Loading chats…</Text>
      ) : isError ? (
        <Stack gap={1}>
          <Alert error={error} />
          <Button onClick={() => void refetch()}>Retry loading chats</Button>
        </Stack>
      ) : data.length === 0 ? (
        <Text>No recent chats</Text>
      ) : (
        <List disablePadding aria-label="Recent chats">
          {data.map((session) => (
            <ListItem key={session.id} disablePadding>
              <ListItemButton
                onClick={() => {
                  selectSession({ sessionId: session.id });
                }}
                selected={sessionId === session.id}
                aria-current={sessionId === session.id ? 'true' : undefined}
                sx={{
                  gap: 2,
                  borderRadius: 1,
                  minWidth: 0,
                  '&:hover, &.Mui-selected:hover': {
                    backgroundColor: (theme) => theme.colors.background.disabled,
                  },
                }}
              >
                <Text variant="body2" color="inherit" noWrap sx={{ flex: 1, minWidth: 0 }}>
                  {getAgenticChatSessionTitle(session)}
                </Text>
                <Text component="span" variant="caption" color="text.secondary" noWrap>
                  <AgenticChatSessionUpdatedTime when={session.updated} />
                </Text>
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      )}
    </Stack>
  );
}
